import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeGetTaskIsInConflict } from "~/store/selectors/selector.taskDependencies.jsx";
import {
  getTaskById,
  makeTaskLabelIdsSelector,
  makeIsTaskFromRecurringSelector,
  makeIsTaskOverdueSelector,
  getTaskViewUrl,
  getTaskHashUrl,
} from "~/store/selectors/selector.tasks.jsx";
import TaskAsListItem from "./TaskAsListItem.jsx";

const TaskAsListItemContainer = ({
  id,
  isDependency,
  completed,
  showConflict,
  showTooltip,
  isAssigneeHidden,
  isProjectNameVisible,
  disabled,
}) => {
  const getTaskLabelIdsSelector = useMemo(makeTaskLabelIdsSelector, []);
  const isTaskFromRecurring = useMemo(makeIsTaskFromRecurringSelector, []);
  const isTaskOverdue = useMemo(makeIsTaskOverdueSelector, []);
  const getIsInConflict = useMemo(makeGetTaskIsInConflict, []);

  const task = useSelector((state) => getTaskById(state, id));
  const fromRecurring = useSelector((state) => isTaskFromRecurring(state, id));
  const overdue = useSelector((state) => isTaskOverdue(state, id));
  const viewUrl = useSelector((state) => getTaskViewUrl(state, id));
  const hashUrl = useSelector((state) => getTaskHashUrl(state, id));
  const labels = useSelector((state) => getTaskLabelIdsSelector(state, id));
  const isInConflict = useSelector((state) => getIsInConflict(state, id));

  return (
    <TaskAsListItem
      id={task.id}
      startOn={task.start_on}
      dueOn={task.due_on}
      assigneeId={task.assignee_id}
      important={task.is_important}
      hiddenFromClients={task.is_hidden_from_clients}
      projectId={task.project_id}
      fromRecurring={fromRecurring}
      overdue={overdue}
      viewUrl={viewUrl}
      hashUrl={hashUrl}
      labels={labels}
      disabled={disabled}
      fake_assignee_name={task.fake_assignee_name}
      isInConflict={isInConflict}
      isDependency={isDependency}
      completed={completed}
      showConflict={showConflict}
      showTooltip={showTooltip}
      isAssigneeHidden={isAssigneeHidden}
      isProjectNameVisible={isProjectNameVisible}
    />
  );
};

TaskAsListItemContainer.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string, // string is used as placeholder ID until backend returns the real ID
    PropTypes.number,
  ]),
  isDependency: PropTypes.bool,
  completed: PropTypes.bool,
  showConflict: PropTypes.bool,
  isAssigneeHidden: PropTypes.bool,
  isProjectNameVisible: PropTypes.bool,
  disabled: PropTypes.bool,
  showTooltip: PropTypes.bool,
};

TaskAsListItemContainer.defaultProps = {
  isDependency: false,
  completed: false,
  showConflict: false,
  isAssigneeHidden: false,
  isProjectNameVisible: false,
  disabled: false,
  showTooltip: false,
};

TaskAsListItemContainer.displayName = `TaskAsListItemContainer`;

export default TaskAsListItemContainer;
